export default __webpack_public_path__ + "static/media/running_jump.868b37dd.gif";